const ADD_TO_CART = 'ADD_TO_CART';
const ADD_TO_CART_WITH_FORMAT = 'ADD_TO_CART_WITH_FORMAT';
const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
const REMOVE_FROM_CART_WITH_FORMAT = 'REMOVE_FROM_CART_WITH_FORMAT';
const CART_LOAD_SUCCESS = 'CART_LOAD_SUCCESS';
const CART_IMAGE_UPLOAD_CHANGE_PROGRESS = 'CART_IMAGE_UPLOAD_CHANGE_PROGRESS';
const CART_IMAGE_UPLOAD_SUCCESS = 'CART_IMAGE_UPLOAD_SUCCESS';
const CART_IMAGE_DELETE_SUCCESS = 'CART_IMAGE_DELETE_SUCCESS';
const CART_CHANGE_FIELD_COMPLETE = 'CART_CHANGE_FIELD_COMPLETE';
const CART_DELETE_ITEM_COMPLETE = 'CART_DELETE_ITEM_COMPLETE';
const CART_DELETE_ALL_COMPLETE = 'CART_DELETE_ALL_COMPLETE';
const CART_VALIDATE_COMPLETE = 'CART_VALIDATE_COMPLETE';
const CART_PAY_START = 'CART_PAY_START';
const CART_PAY_FAIL = 'CART_PAY_FAIL';
const CART_PAY_COMPLETE = 'CART_PAY_COMPLETE';
const CART_PAY_COMPLETE_WITH_ERRORS = 'CART_PAY_COMPLETE_WITH_ERRORS';
const CART_DESTROY = 'CART_DESTROY';
const CART_CHECK_SHOW = 'CART_CHECK_SHOW';
const CART_CHECK_HIDE = 'CART_CHECK_HIDE';

const ADD_TO_CART_URL = '/cart/action/create';
const CART_LOAD_URL = '/cart/list/load';
const CART_IMAGE_UPLOAD_URL = '/cart/image/upload';
const CART_IMAGE_DELETE_URL = '/cart/image/delete';
const CART_CHANGE_FIELD_URL = '/cart/action/change-field';
const CART_DELETE_ITEM_URL = '/cart/action/delete';
const CART_DELETE_ALL_URL = '/cart/action/delete-all';
const CART_VALIDATE_URL = '/cart/action/validate';
const CART_PAY_URL = '/cart/action/pay';

const REDUCER_CART_NAME = 'cart';
const CART_MAX_IMAGES = 5;

export {
  ADD_TO_CART,
  ADD_TO_CART_WITH_FORMAT,
  REMOVE_FROM_CART,
  REMOVE_FROM_CART_WITH_FORMAT,
  CART_LOAD_SUCCESS,
  CART_IMAGE_UPLOAD_CHANGE_PROGRESS,
  CART_IMAGE_UPLOAD_SUCCESS,
  CART_IMAGE_DELETE_SUCCESS,
  CART_CHANGE_FIELD_COMPLETE,
  CART_DELETE_ITEM_COMPLETE,
  CART_DELETE_ALL_COMPLETE,
  CART_VALIDATE_COMPLETE,
  CART_PAY_START,
  CART_PAY_FAIL,
  CART_PAY_COMPLETE,
  CART_PAY_COMPLETE_WITH_ERRORS,
  CART_DESTROY,
  CART_CHECK_SHOW,
  CART_CHECK_HIDE,

  ADD_TO_CART_URL,
  CART_LOAD_URL,
  CART_IMAGE_UPLOAD_URL,
  CART_IMAGE_DELETE_URL,
  CART_CHANGE_FIELD_URL,
  CART_DELETE_ITEM_URL,
  CART_DELETE_ALL_URL,
  CART_VALIDATE_URL,
  CART_PAY_URL,

  REDUCER_CART_NAME,
  CART_MAX_IMAGES,
};
